import React, { useState } from 'react';
import ProductCard from './ProductCard';
import WhatsAppShare from './WhatsAppShare';
import '../styles/CatalogView.css';

function CatalogView({ products, onDelete, onEdit, onToggleVendido }) {
  const [viewMode, setViewMode] = useState('grid');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showWhatsApp, setShowWhatsApp] = useState(false);

  if (products.length === 0) {
    return (
      <div className="catalog-empty">
        <div className="empty-state">
          <p className="empty-icon">📭</p>
          <p className="empty-text">Nenhum produto cadastrado</p>
          <p className="empty-subtext">Comece adicionando seu primeiro produto!</p>
        </div>
      </div>
    );
  }

  const handleWhatsAppClick = (product) => {
    setSelectedProduct(product);
    setShowWhatsApp(true);
  };

  return (
    <div className="catalog-view">
      <div className="catalog-controls">
        <div className="view-toggle">
          <button
            className={`toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
            onClick={() => setViewMode('grid')}
            title="Visualizar em grade"
          >
            ⊞ Grade
          </button>
          <button
            className={`toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
            onClick={() => setViewMode('list')}
            title="Visualizar em lista"
          >
            ≡ Lista
          </button>
        </div>
        <p className="product-count">Total: {products.length} produtos</p>
      </div>

      <div className={`catalog-container catalog-${viewMode}`}>
        {products.map(product => (
          <ProductCard
            key={product.id}
            product={product}
            viewMode={viewMode}
            onDelete={() => onDelete(product.id)}
            onEdit={() => onEdit(product)}
            onWhatsApp={() => handleWhatsAppClick(product)}
            onToggleVendido={() => onToggleVendido(product.id)}
          />
        ))}
      </div>

      {showWhatsApp && (
        <WhatsAppShare
          product={selectedProduct}
          onClose={() => setShowWhatsApp(false)}
        />
      )}
    </div>
  );
}

export default CatalogView;
